import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { fade } from "@material-ui/core/styles/colorManipulator";

const useStyles = makeStyles(({ palette, spacing }) => ({
  rootHeadCell: {
    zIndex: 2,
    background: palette.attachmentsBackground.main,
    minWidth: "220px",
    maxWidth: "290px",
    width: "100%",
    left: 0,
    position: "sticky",
  },
  viewOnlyRootHeadCell: {
    minWidth: "200px",
    maxWidth: "270px",
  },
  marginBox: {
    width: "20px",
    minWidth: "20px",
    height: "100%",
    background: "white",
  },
  headCell: {
    padding: spacing(0, 0.25, 0, 1.5),
    alignItems: "center",
    minHeight: "48px",
    height: "100%",
    width: "100%",
    minWidth: "200px",
    borderBottom: `1px solid ${palette.separator.main}`,
    borderTop: "none",
    borderLeft: `1px solid ${palette.separator.main}`,
    borderRight: `1px solid ${palette.separator.main}`,
    background: palette.attachmentsBackground.main,
  },
  index: {
    fontSize: "10px",
    lineHeight: "120%",
    color: grey[400],
    position: "sticky",
    top: 0,
    left: 0,
    height: "100%",
  },
  rowIndex: {
    position: "absolute",
    left: "-25px",
    top: "-6px",
  },
  headCellInput: {
    all: "unset",
    resize: "none",
    color: palette.contrastText.main,
    margin: "11px 0",
    padding: "5px 0",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "120%",
    width: "100%",
    paddingRight: spacing(2.5),
    whiteSpace: "pre-wrap",
    overflow: "hidden",
    "&:focus": {
      border: `1px solid ${palette.primary.main}`,
      borderRadius: "2px",
      color: palette.contrastText.main,
      background: fade(palette.contrastText.main, 0.1),
      margin: "10px 0",
    },
    "&:hover": {
      border: `1px solid ${palette.primary.main}`,
      borderRadius: "2px",
      background: "transparent",
      margin: "10px 0",
      "&:disabled": {
        border: "none",
        borderRadius: "none",
        background: fade(palette.contrastText.main, 0.34),
        margin: "11px 0",
      },
    },
  },
  headCellInputEmptyValue: {
    border: `1px solid ${palette.error.main} !important`,
    borderRadius: "2px",
    background: "white",
    margin: "10px 0",
  },
  rowTitles: {
    position: "sticky",
    top: 0,
    left: 0,
    height: "100%",
    zIndex: 1,
  },
  deleteRowButtonStandalone: {
    flexShrink: 0,
    alignSelf: "center",
    width: "24px",
    minWidth: "24px",
    padding: 0,
  },
  deleteRowButtonInline: {
    flexShrink: 0,
    width: "24px",
    minWidth: "24px",
    padding: 0,
  },
  makeRowMandatoryButton: {
    position: "absolute",
    padding: "4px",
    minWidth: "16px",
    right: "18px",
    "& path": {
      visibility: "hidden",
    },
    "& .MuiButton-label": {
      width: "16px",
    },
  },
  rowInputWithActions: {
    width: "100%",
    position: "relative",
    justifyContent: "space-between",
    "&:focus path": {
      visibility: "visible",
    },
    "&:hover path": {
      visibility: "visible",
    },
  },
  icon: {
    width: "16px",
    height: "16px",
  },
  disableDeleteRowSVG: {
    fill: grey[300],
  },
  smallRowTitle: {
    width: "48px",
    minWidth: "48px",
    maxWidth: "48px",
    minHeight: "48px",
    maxHeight: "100%",
    background: grey[50],
    borderRight: `1px solid ${palette.separator.main}`,
    borderLeft: `1px solid ${palette.separator.main}`,
    borderBottom: `1px solid ${palette.separator.main}`,
  },
}));

export default useStyles;
